
import Swiper, { Pagination, Autoplay, Navigation }  from 'swiper'

export default {
  name: 'Swiper',
  data: () => ({
    swiper: undefined,
    randomKey: null
  }),
  props: {
    options: {
      type: Object,
      default: () => ({ })
    }
  },
  computed: {
    swiperOptions: {
      get () {
        return Object.assign({}, this.options, {
          modules: [Pagination, Autoplay, Navigation],
          on: {
            init: () => this.$emit('init'),
            activeIndexChange: () => this.$emit('select'),
            slideChange: () => this.$emit('change', this.swiper && this.swiper.activeIndex ? this.swiper && this.swiper.activeIndex : 0),
            sliderMove: (swiper, event) => this.$emit('scroll', event),
            touchStart: () => {
              this.$emit('touchStart')
            },
            touchEnd: () => {
              this.$emit('touchEnd')
            },
            touchMove: () => this.$emit('touchMove'),
            click: (swiper, event) => this.$emit('swiperClick', { event }),
            paginationUpdate: (swiper, paginationEl) => this.$emit('paginationUpdate', { paginationEl })
          }
        })
      }
    }
  },
  mounted () {
    const random = Math.random().toString(36).substring(7)
    this.randomKey = 'SwiperCarousel-' + random
  },
  methods: {
    getIstance() {
      return this.swiper
    },
    goToSlide(i) {
      this.swiper.slideTo(i)
    }
  },
  directives: {
    'swiper': {
      inserted (el, binding, vnode) {
        vnode.context.swiper = new Swiper(el, binding.value)
        vnode.context.$emit('inserted')
      },
      update (el, binding, vnode) {
        if (binding.value !== binding.oldValue) {
          vnode.context.swiper.destroy()
          vnode.context.swiper = new Swiper(el, binding.value)
          vnode.context.$emit('update')
        }
      }
    }
  }
}
